import * as React from 'react';
import * as Styled from './Press.styles';
import { usePressBlock } from '@ids/context';
import Media from '@ids/components/Media';
import Skeleton from '@ids/components/Layout/Skeleton';

const Press = () => {
    const pressBlock = usePressBlock();

    if (!pressBlock || !pressBlock?.mediaItems?.length) {
        return <Skeleton height="160px" />;
    }

    return (
        <Styled.PressSection data-testid="press-block-section" id="press">
            <Styled.Title>{pressBlock.title}</Styled.Title>
            <Styled.ImagesContainer>
                {pressBlock.mediaItems.map(media => (
                    <Styled.ImageWrapper key={media.title}>
                        <Media.Image
                            image={media}
                            layout="intrinsic"
                            width={media.file.details.image.width}
                            height={media.file.details.image.height}
                            sizes="140px"
                        />
                    </Styled.ImageWrapper>
                ))}
            </Styled.ImagesContainer>
        </Styled.PressSection>
    );
};

export default Press;
